type Props = {
  [key: string]: string;
};

export const removeEmpty = (obj: Props): Props => {
  const filteredObj: Props = {};
  Object.keys(obj).forEach(key => {
    if (obj[key]) {
      filteredObj[key] = obj[key];
    }
  });
  return filteredObj;
};
